export default __webpack_public_path__ + "static/Overpass-Bold-be136a677f1db800bb1f489ef69b132f.woff2";